'use client';
import React from "react";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

import wideFactory from '../../../../public/images/gallery/factory/md/factory1-1_640.webp'
import containers from '../../../../public/images/gallery/factory/md/factory3-1_640.webp'
import backFactory from '../../../../public/images/gallery/factory/md/factory1-2_640.webp'
import iso from '../../../../public/images/companyId/ISO_CER.jpg'
import nsf from '../../../../public/images/companyId/NSF_cer.jpg'
import mie from '../../../../public/images/companyId/made_in_egypt.jpg'
import Image from "next/image";

export default function AboutTabsView({data}) {

    const {t} = useTranslation('about')
  const [activeTab, setActiveTab] = React.useState("About Us");
  
 

  return (
    <>
    <Tabs value={activeTab} className="p-6 ">
      <TabsHeader
        className="rounded-none border-b border-blue-gray-50 bg-transparent  flex flex-col lg:flex-row lg:w-2/3 pb-0"
        indicatorProps={{
          className:
            "bg-transparent border-b-2 border-chimib-600 shadow-none rounded-none",
        }}
      >
        {data.map(({ translations }) => {
          if(translations[0]){
          const value = translations[0].headerLabel
          return (<Tab
            key={value}
            value={value}
            onClick={() => setActiveTab(value)}
            className={activeTab === value ? "text-chimib-600" : ""}
          >
            {value}
          </Tab>)
          }else{return ;}
          })}
      </TabsHeader>
      <TabsBody>
        {data.map(({ image, translations }) => {
          if(translations[0]){
          const content = translations[0]
          return (
          <TabPanel key={content.headerLabel} value={content.headerLabel}>
            
            <div className='flex gap-2  justify-evenly p-8 items-center flex-col lg:flex-row '>
                
                <div className="flex flex-col items-center justify-center m-2 lg:m-2 w-full max-w-lg">
                <a href="/about"><h1 className="text-3xl font-extrabold tracking-tight text-chimib-600 sm:text-3xl mb-6 lg:text-4xl lg:hidden">{content.title}</h1></a>
                    
                    <Image 
                        className="w-full   shadow-xl rounded" 
                        src={process.env.CMS_URL + 'assets/' + image.filename_disk} 
                        alt={image.description}
                        width={640}
                        height={360}
                        />
                    
                    </div>

                    <div className="px-4  w-full lg:w-1/2">
                        <a href={content.linkUrl}><h1 className="text-2xl font-extrabold tracking-tight text-chimib-600 sm:text-2xl mb-6 lg:text-3xl hidden lg:block">{content.title}</h1></a>
                    <div dangerouslySetInnerHTML={{__html:content.description}}></div>
                    </div>

                    

                </div>
          </TabPanel>
        )
      
      }else{return ;}
      })}
      </TabsBody>
    </Tabs>
    </>
  );
}